package linkerpangoquipdb

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AuthQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    user_id: String?,
    session_token: String?,
    refresh_token: String?,
    created_at: Long?,
  ) -> T): Query<T> = Query(-1_610_143_588, arrayOf("auth_table"), driver, "Auth.sq", "selectAll", "SELECT auth_table.user_id, auth_table.session_token, auth_table.refresh_token, auth_table.created_at FROM auth_table") { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getLong(3)
    )
  }

  public fun selectAll(): Query<Auth_table> = selectAll(::Auth_table)

  public fun <T : Any> select(user_id: String?, mapper: (
    user_id: String?,
    session_token: String?,
    refresh_token: String?,
    created_at: Long?,
  ) -> T): Query<T> = SelectQuery(user_id) { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getLong(3)
    )
  }

  public fun select(user_id: String?): Query<Auth_table> = select(user_id, ::Auth_table)

  public fun <T : Any> selectLastUserId(mapper: (user_id: String?) -> T): Query<T> = Query(-1_651_149_535, arrayOf("auth_table"), driver, "Auth.sq", "selectLastUserId", "SELECT user_id FROM auth_table ORDER BY created_at DESC LIMIT 1") { cursor ->
    mapper(
      cursor.getString(0)
    )
  }

  public fun selectLastUserId(): Query<SelectLastUserId> = selectLastUserId(::SelectLastUserId)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insert(
    user_id: String?,
    session_token: String?,
    refresh_token: String?,
    created_at: Long?,
  ): Long {
    val result = driver.execute(-560_253_822, """INSERT INTO auth_table (user_id, session_token, refresh_token, created_at) VALUES (?, ?, ?, ?)""", 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, user_id)
          bindString(parameterIndex++, session_token)
          bindString(parameterIndex++, refresh_token)
          bindLong(parameterIndex++, created_at)
        }.await()
    notifyQueries(-560_253_822) { emit ->
      emit("auth_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun update(
    session_token: String?,
    refresh_token: String?,
    created_at: Long?,
    user_id: String?,
  ): Long {
    val result = driver.execute(null, """UPDATE auth_table SET session_token = ?, refresh_token = ?, created_at = ? WHERE user_id ${ if (user_id == null) "IS" else "=" } ?""", 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, session_token)
          bindString(parameterIndex++, refresh_token)
          bindLong(parameterIndex++, created_at)
          bindString(parameterIndex++, user_id)
        }.await()
    notifyQueries(-215_307_630) { emit ->
      emit("auth_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete(user_id: String?): Long {
    val result = driver.execute(null, """DELETE FROM auth_table WHERE user_id ${ if (user_id == null) "IS" else "=" } ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, user_id)
        }.await()
    notifyQueries(-711_919_756) { emit ->
      emit("auth_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAll(): Long {
    val result = driver.execute(-252_877_427, """DELETE FROM auth_table""", 0).await()
    notifyQueries(-252_877_427) { emit ->
      emit("auth_table")
    }
    return result
  }

  private inner class SelectQuery<out T : Any>(
    public val user_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("auth_table", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("auth_table", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(null, """SELECT auth_table.user_id, auth_table.session_token, auth_table.refresh_token, auth_table.created_at FROM auth_table WHERE user_id ${ if (user_id == null) "IS" else "=" } ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, user_id)
    }

    override fun toString(): String = "Auth.sq:select"
  }
}
